module.exports = __webpack_public_path__ + "static/media/naba.904dfd4e.jpg";